<div class="container-fluid">
    <div class="row my-2 justify-content-center">
        <mat-form-field class="col-6 col-md-4">
            <mat-label>Code Echantillon, Analyse, Intervention</mat-label>
            <input matInput placeholder="Code Echantillon, Analyse, Intervention" [(ngModel)]="SearchText" (keyup.enter)="searchIntervention()">
        </mat-form-field>
        <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="primary" (throttledClick)="searchIntervention()" [disabled]="!CanSearch">
            Rechercher
        </button>
        <button *ngIf="Intervention" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent"
                matTooltip="Intervention précedant dans la commande"
                (throttledClick)="navigateToIntervention(ENavigationIntervention.Back)" [disabled]="Intervention.PreviousSampleCodes.length === 0">
            <mat-icon style="transform: scaleX(-1);">forward</mat-icon>
        </button>
        <button *ngIf="Intervention" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent"
                matTooltip="Intervention suivante dans la commande"
                (throttledClick)="navigateToIntervention(ENavigationIntervention.Next)" [disabled]="Intervention.NextSampleCodes.length === 0">
            <mat-icon>forward</mat-icon>
        </button>
        <button *ngIf="Intervention" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent" matTooltip="Aller vers l'intervention"
                (throttledClick)="navigateToIntervention(ENavigationIntervention.Current)">
            <mat-icon>exit_to_app</mat-icon>
        </button>
        <div *ngIf="Intervention && Intervention.Type !== EInterventionType.EAU" class="col-2 d-flex align-items-center">
            <mat-checkbox (change)="checkCOFRAC()" [(ngModel)]="Intervention.COFRAC">COFRAC</mat-checkbox>
        </div>
        <div *ngIf="Intervention && Intervention.Type === EInterventionType.EAU" class="col-2 d-flex align-items-center">
        </div>
    </div>
    <div *ngIf="canGenerateDocuments()">
        <div class="row align-items-center border rounded-1 background-light m-1 p-3">
            <div class="col-12 col-md-4 row">
                <div class="col-6 d-flex align-items-center justify-content-end card-text label">Code d'échantillon</div>
                <div class="col-6 text-left card-text">{{Intervention?.SampleCode}}</div>
            </div>
            <div class="col-12 col-md-4 row">
                <div class="col-6 d-flex align-items-center justify-content-end card-text label">Code Station</div>
                <div class="col-6 text-left card-text">{{Intervention?.ELIMSData?.StationCode}}</div>
            </div>
            <div class="col-12 col-md-4 row">
                <div class="col-6 d-flex align-items-center justify-content-end card-text label">Nom de la Station</div>
                <div class="col-6 text-left card-text">{{Intervention?.ELIMSData?.StationName}}</div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div *ngIf="hasPreleveurRight()" class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(13)"
                        [disabled]="!canGenerateDocuments()">
                    Carte géographique
                </button>
            </div>
            <!-- IBD  -->
            <div *ngIf="Intervention.Type === EInterventionType.IBD" class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(9)"
                        [disabled]="!canGenerateDocuments()">
                    Import IBD Taxons
                </button>
            </div>
            <!-- !IBD  -->
            <div *ngIf="Intervention.Type !== EInterventionType.LAC && (hasLABGTA41() || hasLABGTA29())" class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkIfReportCanBeGenerated(1)"
                        [disabled]="!canGenerateDocuments()">
                    Rapport de prélèvement
                </button>
            </div>
        </div>
        <div class="row justify-content-center">
            <div *ngIf="hasPreleveurRight()" class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(6)"
                        [disabled]="!canGenerateDocuments()">
                    Schéma station
                </button>
            </div>
            <!-- IBD  -->
            <div *ngIf="Intervention.Type === EInterventionType.IBD" class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(7)"
                        [disabled]="!canGenerateDocuments()">
                    Export SEEE
                </button>
            </div>
            <!-- !IBD  -->
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <div class="row g-0">
                    <button *ngIf="Intervention.Type !== EInterventionType.LAC && (hasLABGTA41() || hasLABGTA29())" class="col me-1" appPreventDoubleClick
                            mat-raised-button color="primary"
                            (throttledClick)="checkIfReportCanBeGenerated(EReportCreationType.RapportEssai)"
                            matTooltip="Génération d'une nouvelle version du RE" [disabled]="!canGenerateDocuments()">
                        Rapport d'essai
                    </button>
                    <button *ngIf="Intervention.Type !== EInterventionType.EAU" class="col ms-1"
                            appPreventDoubleClick mat-raised-button color="accent"
                            (throttledClick)="generateReport(2)"
                            matTooltip="Régénération de la version du RE" [disabled]="!canGenerateDocuments()">
                        <mat-icon>autorenew</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="Intervention.Type === EInterventionType.LAC" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkIfReportCanBeGenerated(EReportCreationType.RapportPrelevement)"
                        [disabled]="!canGenerateDocuments()">
                    Rapport de prélèvement
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkIfReportCanBeGenerated(EReportCreationType.RapportInterpretation)"
                        [disabled]="!canGenerateDocuments()">
                    Rapport d'interprétation EAU
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkIfReportCanBeGenerated(EReportCreationType.RapportEssai)"
                        [disabled]="!canGenerateDocuments()">
                    Rapport d'essai EAU
                </button>
            </div>

            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkIfReportCanBeGenerated(EReportCreationType.RapportInterpretationSynthese)"
                        [disabled]="!canGenerateDocuments()">
                    RI Lac Synthèse
                </button>
            </div>

        </div>
        <div *ngIf="Intervention.Type === EInterventionType.LAC && IsInProcess(ELacProcessTypes.PhysiqueChimieInSitu)" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(38)"
                        [disabled]="!canGenerateDocuments()">
                    Données sonde
                </button>
            </div>
        </div>
        <div *ngIf="Intervention.Type === EInterventionType.LAC && IsInProcess(ELacProcessTypes.PrelPhyto)" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkIfReportCanBeGenerated(EReportCreationType.RapportEssaiLacPhyto)"
                        [disabled]="!canGenerateDocuments()">
                    Rapport d'essai phyto
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkIfReportCanBeGenerated(EReportCreationType.RapportPhytoIPLAC)"
                        [disabled]="!canGenerateDocuments()">
                    Rapport d'interprétation IPLAC
                </button>
            </div>
        </div>

        <div *ngIf="Intervention.Type !== EInterventionType.EAU && Intervention.Type !== EInterventionType.LAC && (hasLABGTA41() || hasLABGTA29())"
             class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1"></div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkIfReportCanBeGenerated(3)"
                        [disabled]="!canGenerateDocuments()">
                    Rapport d'interprétation
                </button>
            </div>
        </div>
        <div *ngIf="Intervention.Type === EInterventionType.MPCE && hasLABGTA41()" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkIfReportCanBeGenerated(4)"
                        [disabled]="!canGenerateDocuments()">
                    Saisie Macro-Invertébrés
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkIfReportCanBeGenerated(5)"
                        [disabled]="!canGenerateDocuments()">
                    Soutien Bio Macro-Invertébrés
                </button>
            </div>
        </div>
        <div *ngIf="Intervention.Type === EInterventionType.IBD" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1"></div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkIfReportCanBeGenerated(6)"
                        [disabled]="!canGenerateDocuments()">
                    Soutien Bio Diatomées
                </button>
            </div>
        </div>
        <div *ngIf="Intervention.Type === EInterventionType.LAC && IsInProcess(ELacProcessTypes.PrelPhyto)" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkAndWarnForExistingDocument(EDocumentype.ImportLacTaxons)"
                        [disabled]="!canGenerateDocuments()">
                    Import Liste floristique
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkAndWarnForExistingDocument(EDocumentype.ImportIPLAC)"
                        [disabled]="!canGenerateDocuments()">
                    Import IPLAC
                </button>
            </div>
        </div>
        <div *ngIf="(Intervention.Type === EInterventionType.MPCE || 
                    Intervention.Type === EInterventionType.MGCE || 
                    Intervention.Type === EInterventionType.IBGN)
                    && hasTraiteurTrieur()" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary"
                        (throttledClick)="checkAndWarnForExistingDocument(EDocumentype.FeuillePaillasseTri)"
                        [disabled]="!canGenerateDocuments()">
                    Feuille paillasse tri
                </button>
            </div>
        </div>
        <div *ngIf="Intervention.Type === EInterventionType.IBMR">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkIfReportCanBeGenerated(8)"
                        [disabled]="!canGenerateDocuments()">
                    Saisie Macrophytes
                </button>
            </div>
        </div>
        <div *ngIf="Intervention.Type === EInterventionType.IML" class="row justify-content-center my-2">
            <mat-divider class="col-6 "></mat-divider>
        </div>
        <div *ngIf="Intervention.Type === EInterventionType.IML" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(39)"
                        [disabled]="!canGenerateDocuments()">
                    Import recouvrement
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(44)"
                        [disabled]="!canGenerateDocuments()">
                    Import Suivi Hydro
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(45)"
                        [disabled]="!canGenerateDocuments()">
                    Import Abiotique
                </button>
            </div>
        </div>
        <div class="row justify-content-center my-2">
            <mat-divider class="col-6 "></mat-divider>
        </div>
        <div *ngIf="hasPreleveurRight()" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(1)"
                        [disabled]="!canGenerateDocuments()">
                    Vue d'accès
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(2)"
                        [disabled]="!canGenerateDocuments()">
                    Vue générale
                </button>
            </div>
        </div>
        <div *ngIf="hasPreleveurRight()" class="row justify-content-center">
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(3)"
                        [disabled]="!canGenerateDocuments()">
                    Vue Amont
                </button>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(4)"
                        [disabled]="!canGenerateDocuments()">
                    Vue Aval
                </button>
            </div>
        </div>
        <div *ngIf="hasPreleveurRight()" class="row justify-content-center">
            <span class="col-12 col-sm-4 col-xl-3 p-0 p-sm-1"></span>
            <div class="col-12 col-sm-4 col-xl-3 p-1">
                <button class="w-100" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="checkAndWarnForExistingDocument(5)"
                        [disabled]="!canGenerateDocuments()">
                    Autres
                </button>
            </div>
        </div>
        <div class="row justify-content-center pt-3">
            <mat-accordion class="w-100">
                <mat-expansion-panel>
                    <mat-expansion-panel-header [collapsedHeight]="'60px'">
                        <mat-panel-title class="col">
                            <span [matBadge]="ReportList.length" matBadgePosition="above after" matBadgeSize="small">Rapports</span>
                        </mat-panel-title>
                        <mat-panel-description class="col">
                            Rapports générés
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="row">
                        <div class="col-10 col-md-4 col-xl-2 my-1" *ngFor="let d of ReportList">
                            <div class="card">
                                <h5 class="card-header">{{ getDocumentTypeName(d.DocumentType)}}</h5>
                                <div class="card-body h-100">
                                    <p class="card-text"><small class="text-muted">{{d.Name}}</small></p>
                                </div>
                                <div class="card-footer d-flex flex-row-reverse document-footer align-items-center p-1">
                                    <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="getDocumentFile(d)">
                                        <mat-icon>get_app</mat-icon>
                                    </button>
                                    <mat-icon color="primary" *ngIf="d.Reason" [matTooltip]="d.Reason">info</mat-icon>
                                    <span *ngIf="d.DocumentType === 11 || d.DocumentType === 17" class="col ps-2">V{{d.Version}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header [collapsedHeight]="'60px'">
                        <mat-panel-title class="col">
                            <span [matBadge]="PictureList.length" matBadgePosition="above after" matBadgeSize="small">Photos</span>
                        </mat-panel-title>
                        <mat-panel-description class="col">
                            Photos prises lors de l'intervention
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>

                        <div class="row">
                            <div class="col-10 col-md-4 col-xl-2 m-1" *ngFor="let d of PictureList">
                                <div class="card">
                                    <h5 class="card-header">{{ getDocumentTypeName(d.DocumentType)}}</h5>
                                    <div class="card-body h-100">
                                        <p class="card-text"><small class="text-muted">{{d.Name}}</small></p>
                                    </div>
                                    <div class="card-footer d-flex flex-row-reverse document-footer p-1">
                                        <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="getDocumentFile(d)">
                                            <mat-icon>get_app</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header [collapsedHeight]="'60px'">
                        <mat-panel-title class="col">
                            <span [matBadge]="OtherDocumentList.length" matBadgePosition="above after" matBadgeSize="small">Autres documents</span>
                        </mat-panel-title>
                        <mat-panel-description class="col">
                            Fichiers générés ou intermédiaires
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="row">
                        <div class="col-10 col-md-4 col-xl-2 m-1" *ngFor="let d of OtherDocumentList">
                            <div class="card">
                                <h5 class="card-header">{{ getDocumentTypeName(d.DocumentType)}}</h5>
                                <div class="card-body h-100">
                                    <p class="card-text"><small class="text-muted">{{d.Name}}</small></p>
                                </div>
                                <div class="card-footer d-flex flex-row-reverse document-footer p-1">
                                    <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="getDocumentFile(d)">
                                        <mat-icon>get_app</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>